import { appConfig } from 'brand-config';

/**
 * Whether this brand runs agent payments with amount presets and staff sweep charges (#36683). On for
 * CFM and Forreston, off for Branch and Oakwood. Read from the build-time brand config; the
 * staff-billing-details lambda re-checks the brand-config-be flag, so a bypassed gate can't skip the
 * amount safeguard.
 */
export const isAgentPaymentOptionsEnabled = () => Boolean(appConfig?.featureFlags?.agentPaymentOptions);
